import ProgressiveImage from "react-progressive-graceful-image"

export default function Image (props) {

    return (
        <ProgressiveImage src={props.src} placeholder={props.src}>
        {(src) => <img {...props} src={src} />}
        </ProgressiveImage>
    )
}